import { LightMode, DarkModeRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Tooltip } from 'antd';
import { mode } from 'crypto-js';
import { t } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SetCookie from './Hooks/Cookies/SetCookie';
import Data from "../Data/Data.json"
import GetCookie from './Hooks/Cookies/GetCookie';
import Swal from 'sweetalert2';

const Mode = () => {
    
  const cookieMode = GetCookie(Data.LocalVariable.mode);
  const [mode, setmode] = React.useState(cookieMode? cookieMode.toString(): ()=>{
    SetCookie(Data.LocalVariable.mode, 'light')
    return "light"
  })
  const {t, i18n} = useTranslation();
  

  function SetCookieMode(){
    Swal.fire({
      title : "Passer en mode "+((mode == "light")? "dark" : "light"),
      text: "La page sera rechargé !!!",
      icon: "info",
      background: ((mode == "dark")? "#333" : "#f1f1f1"),
      color: ((mode == "dark")? "#f1f1f1" : "#333" )
      
    }).then((res)=>{
      if(res.isConfirmed){
        SetCookie(Data.LocalVariable.mode, ((mode == "light")? "dark" : "light"))
        setmode((mode == "light")? "dark" : "light")
        window.location.reload()
      }
    })
    //location.href = location.href;
  }


    return (
    <Tooltip title = {(mode == "light")? (t('texte.mode-sombre')) : (t('texte.mode-claire'))}>
        <IconButton
        onClick={SetCookieMode}
        size="large"
        aria-label="display more actions"
        edge="end"
        color="inherit"
        >
            {(mode == "light")? <LightMode /> : <DarkModeRounded />}
        </IconButton>
    </Tooltip>
    );
};

export default Mode;